import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Section, BackgroundImage, MobileBackgroundImage, Content, ImageContainer, TextContent } from './Banner.styles.js';

var _excluded = ["image", "mobileImage", "mainContent", "backgroundColor", "backgroundImage", "mobileBackgroundImage", "textColor", "mobileTextColor", "centerAligned", "layout", "imageAlignment", "contentAlignment"];
var Banner = function Banner(_ref) {
  var _ref$image = _ref.image,
    image = _ref$image === void 0 ? null : _ref$image,
    _ref$mobileImage = _ref.mobileImage,
    mobileImage = _ref$mobileImage === void 0 ? null : _ref$mobileImage,
    _ref$mainContent = _ref.mainContent,
    mainContent = _ref$mainContent === void 0 ? null : _ref$mainContent,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor,
    _ref$backgroundImage = _ref.backgroundImage,
    backgroundImage = _ref$backgroundImage === void 0 ? null : _ref$backgroundImage,
    _ref$mobileBackground = _ref.mobileBackgroundImage,
    mobileBackgroundImage = _ref$mobileBackground === void 0 ? null : _ref$mobileBackground,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? null : _ref$textColor,
    _ref$mobileTextColor = _ref.mobileTextColor,
    mobileTextColor = _ref$mobileTextColor === void 0 ? null : _ref$mobileTextColor,
    _ref$centerAligned = _ref.centerAligned,
    centerAligned = _ref$centerAligned === void 0 ? false : _ref$centerAligned,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? '20/80' : _ref$layout,
    _ref$imageAlignment = _ref.imageAlignment,
    imageAlignment = _ref$imageAlignment === void 0 ? false : _ref$imageAlignment,
    _ref$contentAlignment = _ref.contentAlignment,
    contentAlignment = _ref$contentAlignment === void 0 ? false : _ref$contentAlignment,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Section, _extends({
    className: "leshen-banner",
    backgroundColor: backgroundColor,
    textColor: textColor,
    mobileTextColor: mobileTextColor
  }, props), backgroundImage && /*#__PURE__*/React.createElement(BackgroundImage, {
    mobileBackgroundImage: Boolean(mobileBackgroundImage)
  }, backgroundImage), mobileBackgroundImage && /*#__PURE__*/React.createElement(MobileBackgroundImage, null, mobileBackgroundImage), /*#__PURE__*/React.createElement(Content, {
    layout: layout,
    mobileImage: Boolean(mobileImage),
    hasBackgroundImage: Boolean(backgroundImage)
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    className: "image-container",
    imageAlignment: imageAlignment
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "desktop-image"
  }, image), mobileImage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-image"
  }, mobileImage)), /*#__PURE__*/React.createElement(TextContent, {
    className: "text-content",
    centerAligned: centerAligned,
    contentAlignment: contentAlignment
  }, mainContent)));
};
var Banner$1 = Banner;

export { Banner$1 as default };
//# sourceMappingURL=index.js.map
